import React from 'react';
import { useSocket } from '../../context/SocketContext';
import { 
  WifiIcon, 
  ExclamationTriangleIcon,
  ArrowPathIcon 
} from '@heroicons/react/24/outline';

const ConnectionStatus: React.FC = () => {
  const { isConnected, connectionError, reconnect } = useSocket();

  if (isConnected) {
    return (
      <div className="flex items-center text-green-600">
        <WifiIcon className="h-4 w-4 mr-1" />
        <span className="text-sm font-medium">Conectado</span>
      </div>
    );
  }

  if (connectionError) {
    return (
      <div className="flex items-center space-x-2">
        <div className="flex items-center text-red-600">
          <ExclamationTriangleIcon className="h-4 w-4 mr-1" />
          <span className="text-sm font-medium">Error de conexión</span>
        </div>
        <button
          onClick={reconnect}
          className="text-blue-600 hover:text-blue-800 text-sm underline"
        >
          Reconectar
        </button>
      </div>
    );
  }

  return (
    <div className="flex items-center text-yellow-600">
      <ArrowPathIcon className="h-4 w-4 mr-1 animate-spin" />
      <span className="text-sm font-medium">Conectando...</span>
    </div>
  );
};

export default ConnectionStatus;